<nav class="sidebar" [class.closed]="isClosed" id="sidebar">
  <div class="sidebar-toggle" (click)="toggleSidebar($event)">
    <div class="close-icon" [class.arrowright]="isClosed">
      <img src="assets/images/down-direction.svg" class="arrow" />
    </div>
  </div>
  <div class="top">
    <img
      src="assets/images/logo.webp"
      [class.small]="isClosed"
      alt="NADA logo"
    />
    @if (!isClosed) {
      <app-dealer-select class="dealer-select" />
    }
  </div>
  <ul class="sidebar-menu">
    @for (item of filteredMenuItems; track item.label) {
      @if ((item.children && item.children.length) || !item.children) {
        <li class="menu-item" [class.closedMenu]="isClosed">
          @if (item.isPopup) {
            <a class="menu-item-content" (click)="openSupportPopup($event)">
              @if (item.icon) {
                <img [title]="item.tooltip" [src]="getIconSrc(item)" />
              }
              @if (!isClosed) {
                <span class="item-label">{{ item.label }}</span>
              }
            </a>
          } @else if (item.url) {
            @if (item.external) {
              <a
                class="menu-item-content"
                [href]="item.url"
                target="_blank"
                rel="noopener noreferrer"
              >
                @if (item.icon) {
                  <img [title]="item.tooltip" [src]="getIconSrc(item)" />
                }
                @if (!isClosed) {
                  <span class="item-label">{{ item.label }}</span>
                }
              </a>
            } @else {
              <a
                class="menu-item-content"
                [routerLink]="item.url"
                routerLinkActive="active-parent"
              >
                @if (item.icon) {
                  <img [title]="item.tooltip" [src]="getIconSrc(item)" />
                }
                @if (!isClosed) {
                  <span class="item-label">{{ item.label }}</span>
                }
              </a>
            }
          } @else {
            <div
              class="menu-item-content"
              (click)="isClosed && expandSideMenu($event, $index)"
            >
              @if (item.icon) {
                <img
                  [title]="item.tooltip"
                  class="main-icon"
                  [src]="getIconSrc(item)"
                />
              }
              @if (!isClosed) {
                <span class="item-label" (click)="toggleChildren($index)">{{
                  item.label
                }}</span>
              }
              @if (item.children && !isClosed) {
                <div class="expand-icon" (click)="toggleChildren($index)">
                  <img
                    src="assets/images/down-direction.svg"
                    [class.expand_less]="item.childrenOpen"
                    class="expand-more"
                  />
                </div>
              }
            </div>
          }
          @if (item.children && item.childrenOpen) {
            <ul class="child-menu">
              @for (child of item.children; track child.label) {
                <li>
                  @if (item.childrenOpen && !isClosed) {
                    @if (child.isPopup) {
                      <a
                        (click)="openSupportPopup($event)"
                        class="child-item child-label"
                      >
                        {{ child.label }}
                      </a>
                    } @else if (child.external) {
                      <a
                        [href]="child.url"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="child-item child-label"
                      >
                        {{ child.label }}
                      </a>
                    } @else {
                      <a
                        [routerLink]="child.url"
                        routerLinkActive="active-child"
                        class="child-item child-label"
                      >
                        {{ child.label }}
                      </a>
                    }
                  }
                </li>
              }
            </ul>
          }
        </li>
      }
    }
  </ul>

  <div class="bottom">
    @if (isClosed) {
      <div class="closed-content">
        <p class="nada">NADA</p>
        <p class="group-id">{{ groupName }}</p>
        <p class="group">Group</p>
      </div>
    } @else {
      <app-side-nav-carousel />
    }
  </div>
  <p class="version">v{{ version }}</p>
  @if (showSupportPopup) {
    <app-support (closeClicked)="handleSupportClose()"></app-support>
  }
</nav>
